import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { Timeframe } from '@adornis/bh-timeframes/entities/Timeframe.js';
import type { NarrowedEntityData } from '@adornis/bh-util/selectionset-types.js';
import { Einzelberatung } from './einzelberatung.js';
import { MailTemplateVars } from './mail-templates.js';
import type { User } from './user.js';
import { Workshop } from './workshop.js';

export function getEmailVarsFromUser(
  participatedUser: NarrowedEntityData<User, { title: 1; firstName: 1; lastName: 1 }>,
) {
  return {
    [MailTemplateVars.TITLE]: participatedUser.title ?? '',
    [MailTemplateVars.FIRST_NAME]: participatedUser.firstName,
    [MailTemplateVars.LAST_NAME]: participatedUser.lastName,
  } as any;
}

export function getEmailVarsFromEinzelberatung(
  targetProduct: NarrowedEntity<
    Einzelberatung,
    { _class: 1; name: 1; timeframe: { from: 1; till: 1 }; appointments: { location: 1 } }
  >,
  participatedUser: NarrowedEntityData<User, { title: 1; firstName: 1; lastName: 1 }>,
) {
  return {
    ...getEmailVarsFromUser(participatedUser),

    ...(targetProduct._class === Einzelberatung._class
      ? {
          [MailTemplateVars.WORKSHOP_NAME]: targetProduct.name,
          [MailTemplateVars.WORKSHOP_TERMINE]: targetProduct.timeframe
            ? new Timeframe({ from: targetProduct.timeframe.from, till: targetProduct.timeframe.till })
            : '>UNKNOW DATE<',
          //[MailTemplateVars.WORKSHOP_LOCATION]: targetProduct.appointments.map(ap => ap.location).join(', '),
        }
      : {}),
  };
}

export function getEmailVarsFromWorkshop(
  targetProduct: NarrowedEntity<Workshop, { name: 1; timeframe: { from: 1; till: 1 }; appointments: { location: 1 } }>,
  participatedUser: NarrowedEntityData<User, { title: 1; firstName: 1; lastName: 1 }>,
) {
  return {
    ...getEmailVarsFromUser(participatedUser),

    ...(targetProduct._class === Workshop._class
      ? {
          [MailTemplateVars.WORKSHOP_NAME]: targetProduct.name,
          [MailTemplateVars.WORKSHOP_TERMINE]: targetProduct.timeframe
            ? new Timeframe({ from: targetProduct.timeframe.from, till: targetProduct.timeframe.till })
            : '>UNKNOW DATE<',
          [MailTemplateVars.WORKSHOP_LOCATION]: targetProduct.appointments.map(ap => ap.location).join(', '),
        }
      : {}),
  };
}
